module.exports = __webpack_public_path__ + "static/media/road.21513321.png";